import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

const jwtHelper = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  public setToken(token: string, orgId: number, scopes: string[]) {
    localStorage.setItem('token', token);
    localStorage.setItem('orgId', orgId.toString());
    localStorage.setItem('scopes', JSON.stringify(scopes));
    sessionStorage.removeItem('logoutUrl');
  }

  public logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('orgId');
    localStorage.removeItem('scopes');
  }

  public setOrgId(orgId: string) {
    localStorage.setItem('orgId', orgId.toString());
  }

  public setLogoutUrl(logoutUrl: string | null) {
    if (!logoutUrl) {
      sessionStorage.removeItem('logoutUrl');
    } else {
      sessionStorage.setItem('logoutUrl', logoutUrl);
    }
  }

  public getLogoutUrl(): string | null {
    return sessionStorage.getItem('logoutUrl');
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  public getScopes(): string[] {
    return JSON.parse(localStorage.getItem('scopes') ?? '[]');
  }

  public hasScope(scope: string) {
    const scopes = this.getScopes();
    return scopes.includes(scope) || scopes.includes('iam:admin');
  }

  public isAdmin() {
    return this.hasScope('iam:admin');
  }

  public getOrgId() {
    return Number(localStorage.getItem('orgId'));
  }

  public isAuthenticated(): boolean {
    const token = this.getToken();
    if (token == null || this.getOrgId() == null) {
      return false;
    }

    return !jwtHelper.isTokenExpired(token);
  }
}
